import { tokenFromFragment } from '@rollcall/contracts'

/**
 * Разбор ссылки-приглашения от мастера (D51, D55).
 *
 * Ссылка одна на кампанию, и токен у неё во фрагменте адреса
 * (`inviteLink` в contracts): так он не уходит ни в лог раздачи
 * статики, ни в `Referer`. Разбирать её человеку не нужно — он
 * вставляет то, что ему прислали, целиком.
 *
 * Принимается и полный адрес, и один фрагмент: из мессенджера
 * копируется по-разному, а требовать «вставьте ровно ссылку» —
 * перекладывать на человека работу, которую делает одна строчка.
 *
 * Прежняя пара «кампания и место» (D8) больше не принимается: таких
 * ссылок никто не выдаёт с D51, а принимать формат, которого нет,
 * значит обещать вход, которого нет.
 *
 * Отказ всегда с причиной. «Неверная ссылка» без объяснения оставляет
 * человека гадать, что именно не так.
 */

export type InviteRefusal = 'empty' | 'not-a-link' | 'no-token'

export type InviteParsed =
  | { readonly ok: true; readonly token: string }
  | { readonly ok: false; readonly reason: InviteRefusal }

export function parseInvite(input: string): InviteParsed {
  const trimmed = input.trim()
  if (trimmed === '') return { ok: false, reason: 'empty' }

  const at = trimmed.indexOf('#')
  // Без «#» это либо не ссылка вовсе, либо голый фрагмент —
  // «token=…», как его копируют из адресной строки.
  const fragment = at >= 0 ? trimmed.slice(at + 1) : trimmed
  if (!fragment.includes('=')) return { ok: false, reason: 'not-a-link' }

  const token = tokenFromFragment(fragment)
  if (token === null) return { ok: false, reason: 'no-token' }
  return { ok: true, token }
}

/** Строка запроса приглашения: то, с чем приложение работает дальше. */
export function inviteSearch(campaignId: string, seatId: string): string {
  const params = new URLSearchParams({ campaign: campaignId, seat: seatId })
  return `?${params.toString()}`
}
